export default "__VITE_ASSET__6e420c80__"